import Vue from "vue";
import axios from "axios";
import router from "../router/index";
import { debounce } from "throttle-debounce";
import ElementUI from "element-ui";

// 创建
const $axios = axios.create({
  headers: {
    "Content-Type": "application/json",
    "Accept": "text/html, */*",
    "X-Requested-With": "XMLHttpRequest",
    'Cache-Control': 'max-age=10' // http 资源在客户端缓存时长
  },
  baseURL: "/manager",
});

// 请求拦截器
$axios.interceptors.request.use((config) => {
  let token = localStorage.getItem("token");
  if (token) {
    config.headers["token"] = token;
  }
  return config;
});

/* 会话失效弹窗提示 */
const timeoutMessageBox = debounce(500, () => {
  ElementUI.MessageBox.alert("您的登录已经超时，请点击按钮重新登录", "提示", {
    center: true,
    confirmButtonText: "重新登录",
    callback: () => {
      router.push("/login");
    },
  });
});
/* 激活未系統弹窗提示 */
const enableMessageBox = debounce(500, (msg) => {
  ElementUI.MessageBox.alert(msg, "提示", {
    center: true,
    confirmButtonText: "去激活",
    callback: () => {
      router.push("/systemManager/activation");
    },
  });
});

/* 会话失效弹窗提示 */
const permissionDenyMessageBox = debounce(500, () => {
  ElementUI.MessageBox.alert("您没有访问当前页面的权限", "提示", {
    center: true,
    confirmButtonText: "确定",
  });
});

// 添加响应拦截器 code码后期和后端约定
$axios.interceptors.response.use(
  (response) => {
    if (response.data.code === 401) {
      timeoutMessageBox();
    } else if (response.data.code === 405) {
      enableMessageBox(response.data.msg);
    }
    return response;
  },
  (error) => {
    Vue.nextTick(() => {
      if (error.response) {
        switch (error.response.code) {
          case 403: {
            permissionDenyMessageBox();
            break;
          }
          case 401: {
            timeoutMessageBox();
            break;
          }
          case 405: {
            enableMessageBox()
            break;
          }
          case 502: {
            break;
          }
          default: {
            break;
          }
        }
      }
    });
    return Promise.reject(error);
  }
);

/* 引入ajax请求方案 */
export function ajax(config) {
  config.instance = this;
  return $axios(config);
}
